<div class="follow-up-selector">
  <div class="follow-up-selector__illustration">
    <img [src]="actionImage" [alt]="title" />
  </div>

  <div class="follow-up-selector__option">
    <h3 class="rc-title-delta">{{ title }}</h3>
    <p class="description rc-paragraph">{{ description }}</p>
  </div>

  <div class="follow-up-selector__footer">
    <rc-button data-qa="vs-follow-up-popin-button-action" [attr.variant]="isRecommended ? 'primary' : 'secondary-alt'" (click)="onClick()">
      {{ actionLabel | titlecase }}
    </rc-button>
  </div>
</div>
